/* eslint-disable */

/**
 * Parse all words inside a text with "#" or "@" for a twitter link transformation.
 * @param {*} regexHasTag
 * @param {*} regexArobas
 * @param {*} text
 * @returns
 */
const createTwitterLink = (regexHashTag, regexArobas, text) => {
  let textBrut = text;
  if (text.match(regexHashTag) !== null) {
    const wordsWithHashTag = text.match(regexHashTag);
    wordsWithHashTag.forEach(word => {
      let wordWithoutSign = word.slice(1);
      textBrut = textBrut.replace(
        word,
        `<a class="text-link" href="https://twitter.com/hashtag/${wordWithoutSign}?src=hashtag_click" target="_blank" rel="noopener" aria-label="Twitter Hashtag ${wordWithoutSign}">${word}</a>`
      );
    });
  }

  if (text.match(regexArobas) !== null) {
    const wordsWithHArobas = text.match(regexArobas);
    wordsWithHArobas.forEach(word => {
      let wordWithoutSign = word.slice(1);
      textBrut = textBrut.replace(
        word,
        `<a class="text-link" href="https://twitter.com/${wordWithoutSign}" target="_blank" rel="noopener"  aria-label="Twitter ${wordWithoutSign}">${word}</a>`
      );
    });
  }

  var httpRegex = /^(http|https):\/\//;
  const splited = textBrut.split(" ");
  splited.forEach((word, index) => {
    if (word.match(httpRegex)) {
      splited [
        index
      ] = `<a class="text-link" href="${word}" target="_blank" rel="noopener">${word}</a>`;
    }
  });

  const textFormated = splited.join(" ");
  return textFormated;
};

export default createTwitterLink;
